import {NgModule} from '@angular/core';
import {SharedModule} from "../../../shared.module";
import {CartSavedProductComponent} from "./cart-saved-product.component";

@NgModule({
    imports: [
        SharedModule
    ],
    exports: [
        CartSavedProductComponent
    ],
    declarations: [
        CartSavedProductComponent
    ]
})
export class CartSavedProductModule {
}
